if (!customElements.get('rdb-ad-rose-range')) {
  customElements.define('rdb-ad-rose-range', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.items = Array.from(this.querySelectorAll('[data-rose-range-item]'));
      this.more = this.querySelector('[data-rose-range-more]');
      this.status = this.querySelector('[data-rose-range-status]');
      if (!this.items.length || !this.more || !this.status) return;
      this.initialized = true;
      this.step = Math.max(1, Number(this.dataset.step) || 16);
      this.visibleCount = Math.min(this.items.length, Math.max(1, Number(this.dataset.initial) || 12));
      this.more.addEventListener('click', () => this.reveal());
      this.update();
    }

    update() {
      this.items.forEach((item, index) => { item.hidden = index >= this.visibleCount; });
      this.more.hidden = this.visibleCount >= this.items.length;
      this.status.textContent = this.status.dataset.countLabel.replace('[count]', String(this.visibleCount));
    }

    reveal() {
      const firstNewItem = this.items[this.visibleCount];
      this.visibleCount = Math.min(this.items.length, this.visibleCount + this.step);
      this.update();
      if (!firstNewItem) return;
      const productLink = firstNewItem.querySelector('h3 a');
      if (productLink) productLink.focus({ preventScroll: true });
      firstNewItem.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
  });
}
